import "react-loading-skeleton/dist/skeleton.css";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";

import Wrapper from "../../StylesWrappers/Stat/statCard";

const StatCardSkeleton = () => {
  return (
    <StatPageWrapper>
      <Wrapper>
        <section>
          <StatWrapper>
            <Skeleton width={50} height={40} />
            <Skeleton width={50} height={40} />
          </StatWrapper>
          <Skeleton width={200} height={25} style={{ marginTop: "50px" }} />
        </section>
      </Wrapper>
      <Wrapper>
        <section>
          <StatWrapper>
            <Skeleton width={50} height={40} />
            <Skeleton width={50} height={40} />
          </StatWrapper>
          <Skeleton width={200} height={25} style={{ marginTop: "50px" }} />
        </section>
      </Wrapper>
      <Wrapper>
        <section>
          <StatWrapper>
            <Skeleton width={50} height={40} />
            <Skeleton width={50} height={40} />
          </StatWrapper>
          <Skeleton width={200} height={25} style={{ marginTop: "50px" }} />
        </section>
      </Wrapper>
    </StatPageWrapper>
  );
};

export default StatCardSkeleton;

const StatPageWrapper = styled.main`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  justify-items: center;
  margin: 2.5rem 4vw;
`;

const StatWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
